import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Forms from "./forms";
import MenusTranslations from "./menusTranslations";

const feature = "menusTranslations";

const InitialState = Record({
  forms: new Forms(),
  menusTranslations: new MenusTranslations()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function MenusTranslationsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.menusTranslations
    ) {
      state = state.updateIn(
        ["menusTranslations", "entities"],
        map => map.mergeDeep(action.payload.entities.menusTranslations)
      );
    }
  }

  switch (action.type) {
    case actions.POST_MENUS_TRANSLATIONS: {
      return disableForm(state, "createMenusTranslation");
    }
    case actions.POST_MENUS_TRANSLATIONS_SUCCESS: {
      state = clearForm(state, "createMenusTranslation", Forms);
      return enableForm(state, "createMenusTranslation");
    }
    case actions.POST_MENUS_TRANSLATIONS_ERROR: {
      state = enableForm(state, "createMenusTranslation");
      return setFormErrors(
        state,
        "createMenusTranslation",
        action.payload.errors
      );
    }

    case actions.PATCH_MENUS_TRANSLATION: {
      return state.setIn(["menusTranslations", "loading"], true);
    }
    case actions.PATCH_MENUS_TRANSLATION_SUCCESS: {
      return state.setIn(["menusTranslations", "loading"], false);
    }
    case actions.PATCH_MENUS_TRANSLATION_ERROR: {
      return state.setIn(["menusTranslations", "loading"], false);
    }

    case actions.DELETE_MENUS_TRANSLATION: {
      return state.deleteIn([
        "menusTranslations",
        "entities",
        action.payload.uid
      ]);
    }

    case actions.GET_MENUS_TRANSLATION_FIELDS: {
      return state.setIn(["menusTranslations", "loading"], true);
    }
    case actions.GET_MENUS_TRANSLATION_FIELDS_SUCCESS: {
      state = state.setIn(
        ["menusTranslations", "entities", action.meta.uid, "menuItems"],
        action.payload.result
      );
      return state.setIn(["menusTranslations", "loading"], false);
    }
    case actions.GET_MENUS_TRANSLATION_FIELDS_ERROR: {
      return state.setIn(["menusTranslations", "loading"], false);
    }

    case actions.POST_MENUS_TRANSLATION_FIELDS: {
      return disableForm(state, "createMenusTranslationMenuItems");
    }
    case actions.POST_MENUS_TRANSLATION_FIELDS_SUCCESS: {
      state = clearForm(state, "createMenusTranslationMenuItems", Forms);
      return enableForm(state, "createMenusTranslationMenuItems");
    }
    case actions.POST_MENUS_TRANSLATION_FIELDS_ERROR: {
      state = enableForm(state, "createMenusTranslationMenuItems");
      return setFormErrors(
        state,
        "createMenusTranslationMenuItems",
        action.payload.errors
      );
    }

    case actions.SET_MENU_TRANSLATION_DATA_OBJECT: {
      return state.setIn(
        ["menusTranslations", "entities", action.payload.uid, "dataObject"],
        action.payload.menuDataObject
      );
    }

    case actions.MOVE_MENU_ITEM: {
      let menu = state.getIn([
        "menusTranslations",
        "entities",
        action.payload.moveActionProps.uid,
        "dataObject"
      ]);
      let dragIndex = null;
      let hoverIndex = null;
      let dragItem = null;
      menu.forEach(function(item, index) {
        if (item.uid === action.payload.dragIndex) {
          dragIndex = index;
          dragItem = item;
        }
        if (item.uid === action.payload.hoverIndex) {
          hoverIndex = index;
        }
      });

      menu.splice(dragIndex, 1);
      menu.splice(hoverIndex, 0, dragItem);
      state = state.setIn(
        [
          "menusTranslations",
          "entities",
          action.payload.moveActionProps.uid,
          "dataObject"
        ],
        []
      );
      return state.setIn(
        [
          "menusTranslations",
          "entities",
          action.payload.moveActionProps.uid,
          "dataObject"
        ],
        menu
      );
    }

  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/menuTranslations/reducer.js